module.exports = "/_next/static/images/Hero-834677cc46589402b0b1226e4c756a9d.webp";